module.exports = __webpack_public_path__ + "img/internet_connected.ef83556d.svg";